import { handleApi } from './common';

export const HNS_API_CONSTANTS = {
  categories: 'relay/hns/api/categories',
  subCategories: 'relay/hns/api/sub_categories',
  faq: 'relay/hns/api/faqs',
  descApi: 'relay/hns/api/faq/',
  likeDislikeApi: `relay/hns/api/faq/<faq_id>/action`,
  search: 'relay/hns/api/faq/search',
  ticket: 'relay/hns/api/freshdesk/ticket/all',
  conversation: 'relay/hns/api/freshdesk/ticket/<ticket_id>/conversations',
  writeToUs: 'relay/hns/api/freshdesk/ticket/create',
  reply: 'relay/hns/api/freshdesk/ticket/<ticket_id>/reply',
};

export const fetch_categories = async (Api, token) => {
  const url = HNS_API_CONSTANTS.categories;
  const response = await Api.get(url, {}, {}, token);
  return handleApi(response);
};

export const fetch_sub_categories = async (Api, categoryId, token) => {
  const url = HNS_API_CONSTANTS.subCategories + `?category_id=${categoryId}`;
  const response = await Api.get(url, {}, {}, token);
  return handleApi(response);
};

export const fetch_faq = async (Api, subCategoryId, token) => {
  const url = HNS_API_CONSTANTS.faq + `?sub_category_id=${subCategoryId}`;
  const response = await Api.get(url, {}, {}, token);
  return handleApi(response);
};

export const fetch_faq_answers = async (Api, faqId, token) => {
  const url = HNS_API_CONSTANTS.descApi + `/${faqId}/desc`;
  const response = await Api.get(url, {}, {}, token);
  return handleApi(response);
};

export const triggerFeedback = async (Api, action, faqId, token = '') => {
  const url =
    HNS_API_CONSTANTS.likeDislikeApi.replace('<faq_id>', faqId) +
    '?action=' +
    action;
  const response = await Api.post(url, {}, {}, token);
  return handleApi(response);
};

export const fetch_search = async (Api, word, token) => {
  const url = HNS_API_CONSTANTS.search + '?word=' + word;
  const response = await Api.get(url, {}, {}, token);
  return handleApi(response);
};

export const fetch_user_tickets = async (Api, status, token) => {
  const url = HNS_API_CONSTANTS.ticket + '?status=' + status;
  const response = await Api.get(url, {}, {}, token);
  return handleApi(response);
};

export const fetch_conversation = async (Api, ticketId, token) => {
  const url = HNS_API_CONSTANTS.conversation.replace('<ticket_id>', ticketId);
  const response = await Api.get(url, {}, {}, token);
  return handleApi(response);
};

export const create_ticket = async (Api, oldTicketId, data, token) => {
  const url = HNS_API_CONSTANTS.writeToUs;

  let body_data = new FormData();
  body_data.append('subject', data.subject);
  body_data.append('description', data.description);
  body_data.append('product', data.product);
  body_data.append('cf_category', data.category);
  body_data.append('cf_subcategory', data.sub_category);
  data.attachments.forEach((item) => {
    body_data.append('res[]', item, item.name);
  });
  if (oldTicketId) {
    body_data.append('cf_old_ticket_reference_id', oldTicketId);
  }

  const response = await Api.post(url, body_data, {}, token);
  return handleApi(response);
};

export const reply_ticket = async (Api, ticketId, data, token) => {
  const url = HNS_API_CONSTANTS.reply.replace('<ticket_id>', ticketId);

  let body_data = new FormData();
  body_data.append('description', data.description);
  if (data.attachments.length > 0) {
    data.attachments.forEach((item) => {
      body_data.append('res[]', item, item.name);
    });
  }

  const response = await Api.post(url, body_data, {}, token);
  return handleApi(response);
};